import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined'
import { IconButton, Tooltip, MenuItem, Typography, ListItemText, ListItemIcon } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'

export type CopyEntityType =
  | 'agreement'
  | 'core-data'
  | 'custom-field'
  | 'form-template'
  | 'integration'
  | 'organisation'
  | 'purchase-order'
  | 'request'
  | 'supplier'
  | 'user'
  | 'workflow'

type Props = {
  id: Nullish<string>
  entityType: CopyEntityType
  inDropdown?: boolean
  inDropdownWithIcon?: boolean
}

export const CopyIdButton: React.FC<Props> = ({ id, entityType, inDropdown = false, inDropdownWithIcon = false }) => {
  const { user } = useAuthenticatedUser()
  const { t } = useTranslation('common', { keyPrefix: 'copy-button' })
  const entityLabel = t(`entity.${entityType}`)
  const title = t('copy-id', { entityLabel })

  if (!user.isOmnean) return null
  if (!id) return null

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(id)
      enqueueSnackbar(t('copy-id-success', { entityLabel }), { variant: 'success' })
    } catch {
      enqueueSnackbar(t('copy-id-error', { entityLabel }), { variant: 'error' })
    }
  }

  if (inDropdown) {
    return (
      <MenuItem onClick={() => void handleClick()}>
        <Typography>{title}</Typography>
      </MenuItem>
    )
  }

  if (inDropdownWithIcon) {
    return (
      <MenuItem onClick={() => void handleClick()}>
        <ListItemIcon>
          <IntegrationInstructionsOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={title} />
      </MenuItem>
    )
  }

  return (
    <Tooltip title={title}>
      <IconButton onClick={() => void handleClick()}>
        <IntegrationInstructionsOutlinedIcon />
      </IconButton>
    </Tooltip>
  )
}
